import { useEffect, useState } from "react";
import AppInitSingletonBo from "./AppInitSingletonBo";
import AppInitConsumer from "./AppInitConsumer";
import useWizardFormCtx from "../../ui/page/wizard/ctx-provider/useWizardFormCtx";
import WizardFormBo from "../../ui/page/wizard/ctx-provider/WizardFormBo";
import useAppCtx from "../../app/ctx-provider/useAppCtx";
import StvPage from "../../app/ctx-provider/StvPage";
import useUnauthorized from "../../app/useUnauthorized";
import BackendService from "../common/BackendService";
import GoogleTagManager from "../../gtm/GoogleTagManager";
import StringUtil from "../../app/util/StringUtil";

const useAppInit = (jwt?: string) => {
    const { handleUnauthorized } = useUnauthorized();
    const [loading, setLoading] = useState(false);

    const { fireWizardFormBo } = useWizardFormCtx();
    const { appCtxBo, setAppCtxBo } = useAppCtx();

    const initAppSessionAsync = async (jwt?: string) => {
        const uiSessionId = await AppInitConsumer.initAppSession(jwt);
        AppInitSingletonBo.initAppSession(uiSessionId);
        return AppInitSingletonBo.isUiSessionIdValid();
    }

    const initAppDataAsync = async () => {
        const root = await AppInitConsumer.initAppData();

        // Formulardaten werden importiert
        const newWizardFormBo = WizardFormBo.importFormulardaten(root.formulardaten);
        fireWizardFormBo(newWizardFormBo);

        AppInitSingletonBo.initAppData(root.partnernrVorh, root.vertragLaufzeitJahre, root.vermittler, root.kampagne);

        // GoogleTagManager
        const vmnrVorh = !StringUtil.isBlank(root.vermittler.vmnr);
        GoogleTagManager.fireEventAppInit(vmnrVorh, root.partnernrVorh);
    }

    const initApp = async () => {
        BackendService.setUnauthorizedFunction(handleUnauthorized);

        const isUiSessionIdValid = await initAppSessionAsync(jwt);

        if (isUiSessionIdValid) {
            await initAppDataAsync();
        } else {
            appCtxBo.currentPage = StvPage.SESSION_INVALID;
            setAppCtxBo(appCtxBo);
        }

    }

    // wird nur einmmal aufgerufen    
    useEffect(() => {
        // Abbruch: Unmount
        let cancel = false;

        setLoading(true);

        initApp()
            .catch(error => {
                if (cancel) { return; }

                appCtxBo.currentPage = StvPage.ERROR;
                setAppCtxBo(appCtxBo);
            }).finally(() => {
                if (cancel) { return; }
                setLoading(false);
            });

        // Cleanup function that will be called on
        // 1. Unmount
        // 2. Dependency Array Change
        return () => { cancel = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading };
};

export default useAppInit;